/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
} from 'material-react-table';
import {
  Pagination,
  Typography,
  TextField,
  Button,
  Box,
  InputAdornment,
  useMediaQuery,
  PaginationItem,
} from '@mui/material';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import download from 'packages/novous_web/src/assets/icons/download.svg';
import add from 'packages/novous_web/src/assets/icons/add.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import bulkUpload from 'packages/novous_web/src/assets/icons/bulkUpload.svg';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import CustomFilterModal from 'packages/novous_web/src/common/components/CustomFilterModal';
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import useApiError from 'packages/novous_web/src/api/useApiError';
import BulkUploadModal from 'packages/novous_web/src/common/components/BulkUpload';
import eye from "packages/novous_web/src/assets/icons/Eye.svg";
interface Address {
  addressCode: string;
  name: string;
  address: string;
  type: string;
  controlOffice: string;
}

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

interface TripDataTableProps {
  handleTile: (data: ColumnObjType) => void;
}
interface FilterField {
  key: string;
  label: string;
  options?: { value: string; label: string }[];
  defaultValue?: string;
  input?: boolean; // <-- New field to toggle between input and dropdown
}

const AddressesDataTable: React.FC<TripDataTableProps> = ({ handleTile }) => {
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
  const [isUploadModelOpen, setIsUploadModelOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [data, setData] = useState<Address[]>([]);
  const [filteredData, setFilteredData] = useState<Address[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedTrip, setSelectedTrip] = useState<any>(null);
  const isSmallScreen = useMediaQuery('(max-width:850px)');
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedArr, setPaginatedArr] = useState<any[]>([null]);
  const totalPages = useRef(paginatedArr.length);

  const pageSize = 5;
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const { user } = useAuth();
  const [filterData, setFilterData] = useState<any>({ data: {}, isfiltered: false });
  const navigate = useNavigate();
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const handleClose = () => setIsCustomiseModalOpen(false);
  const handleUploadModalClose = () => setIsUploadModelOpen(false);
  const handleReset = () => {
    console.info('Reset clicked!');
    setTilesObj({
      Stat1: { name: 'Total Addresses', status: true },
      Stat2: { name: 'Geofenced Addresses', status: true },
      Stat3: { name: 'Active Trip Addresses', status: true },
      Stat4: { name: 'Unused Addresses', status: true },
    });
    // your reset logic here
  };
  // New state for customize modal and column configuration
  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);
  const [tilesObj, setTilesObj] = useState<ColumnObjType>({
    Stat1: { name: 'Total Addresses', status: true },
    Stat2: { name: 'Geofenced Addresses', status: true },
    Stat3: { name: 'Active Trip Addresses', status: true },
    Stat4: { name: 'Unused Addresses', status: true },
  });
  const [columnObj, setColumnObj] = useState<ColumnObjType>({
    addressCode: { name: 'Address Code', status: true },
    name: { name: 'Name', status: true },
    address: { name: 'Address', status: true },
    type: { name: 'Type', status: true },
    controlOffice: { name: 'Control Office', status: true },
    actions: { name: 'Actions', status: true },
  });
  const typeOptions = [
    { value: 'Consignor', label: 'Consignor' },
    { value: 'Consignee', label: 'Consignee' },
    { value: 'Other', label: 'Other' },
  ];

  const categoryOptions = [
    { value: 'TOLL PLAZA', label: 'Toll Plaza' },
    { value: 'FOOD STATION', label: 'Food Station' },
    { value: 'PLAT FACTORY', label: 'Plat/Factory' },
    { value: 'PARKING PLACE', label: 'Parking Place' },
    { value: 'WEIGHING BRIDGE', label: 'Weighing Bridge' },
    { value: 'SERVICE CENTER', label: 'Service Center' },
    { value: 'FUEL PUMP', label: 'Fuel Pump' },
    { value: 'HOTEL FOR STAY', label: 'Hotel for Stay' },
    { value: 'FORD SERVICE STATION', label: 'Ford Service Station' },
    { value: 'STATION', label: 'Station' },
    { value: 'DUMPING ZONE', label: 'Dumping Zone' },
    { value: 'OIL DEPO', label: 'Oil Depo' },
    { value: 'GEO ZONE', label: 'Geo Zone' },
    { value: 'RESTRICTED LOCATIONS', label: 'Restricted Locations' },
    { value: 'KDFB ACM ROUTE', label: 'KDFB ACM Route' },
    { value: 'WAREHOUSES', label: 'Warehouses' },
  ];
  let filterFileds: FilterField[] = [];

  const { data: addressFilterData, fetchData: fetchAddressFilterData } = useAxios<{
    data: { addressBookEntities: any[]; lastEvaluatedKey: null };
  }>(`${API_ENDPOINTS.directories.ADDRESS_FILTER}`, 'POST');
  const {
    data: downloadTripData,
    error: downloadTripError,
    loading: downloadTripLoading,
    fetchData: fetchDownloadTripData,
  } = useApiError<any>(`${API_ENDPOINTS.directories.ADDRESS_DOWNLOAD}`, 'POST', 'blob');

  // Download handler

  useEffect(() => {
    if (downloadTripData) {
      try {
        if (downloadTripData instanceof Blob) {
          const url = window.URL.createObjectURL(downloadTripData);
          const a = document.createElement('a');
          a.href = url;
          let extension = selectedFormat.toLowerCase();
          if (extension === 'excel') {
            extension = 'xlsx'; // Use xlsx for Excel format
          }

          const fileName = `address_detail_data.${extension}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          console.error('Invalid response format. Expected a Blob.');
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      } finally {
        setIsDownloadModalOpen(false);
      }
    }
  }, [downloadTripData]);

  // const handleDownload = async () => {
  //   fetchDownloadTripData({ fleetId: user?.customer_id, fileType: selectedFormat });
  // };

  const handleDownload = async () => {
    setIsSendingEmail(true);
    const requestData = {
      fleetId: user?.customer_id,
      fileType: selectedFormat,
    };

    try {
      const response = await fetchDownloadTripData(requestData);
      if (
        response?.type === 'text/csv' ||
        response?.type === 'application/pdf' ||
        response?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        setAlertMessage(`File has been downloaded successfully`);
        setAlertType('success');
        setAlertOpen(true);
      } else {
        setAlertMessage(response?.error);
        setAlertType('error');
        setAlertOpen(true);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setAlertMessage((error as Error).message);
      setAlertType('error');
      setAlertOpen(true);
    } finally {
      setIsSendingEmail(false);
    }
  };

  filterFileds = [
    {
      key: 'address',
      label: 'Address',
      input: true,
    },
    {
      key: 'type',
      label: 'Type',
      options: typeOptions,
    },
    {
      key: 'city',
      label: 'City',
      input: true,
    },
    {
      key: 'category',
      label: 'Category',
      options: categoryOptions,
    },
    {
      key: 'state',
      label: 'State',
      input: true,
    },
    {
      key: 'pincode',
      label: 'Pincode',
      input: true,
    },
  ];

  useEffect(() => {
    if (filterData.isfiltered) {
      fetchAddressFilterData({
        address: filterData.data.address ? filterData.data.address : '',
        type: filterData.data.type ? filterData.data.type : '',
        city: filterData.data.city ? filterData.data.city : '',
        category: filterData.data.category ? filterData.data.category : '',
        state: filterData.data.state ? filterData.data.state : '',
        pincode: filterData.data.pincode ? filterData.data.pincode : '',
        lastEvaluatedKey: null,
        fleetId: user?.customer_id,
      });
    } else {
      fetchAddressData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
    }
    setCurrentPage(1);
    setPaginatedArr([null]);
  }, [filterData]);

  const {
    data: addressData,
    error: routesError,
    loading: routesLoading,
    fetchData: fetchAddressData,
  } = useAxios<{ data: { arrayObjectList: any[]; lastEvaluatedKey: null } }>(
    `${API_ENDPOINTS.dashboard.GET_ADDRESS}`,
    'POST',
  );

  useEffect(() => {
    if (user?.customer_id) {
      fetchAddressData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
    }
  }, [user?.customer_id]);

  useEffect(() => {
    if (addressData?.data) {
      const addressListData: Address[] = addressData.data.arrayObjectList.map((route) => ({
        addressCode: route.addressCode,
        name: route.name,
        address: route.address,
        type: route.type,
        controlOffice: route.sourceName,
      }));
      setData(addressListData);
    }
  }, [addressData]);

  useEffect(() => {
    if (addressFilterData?.data) {
      const addressListData: Address[] = addressFilterData.data.addressBookEntities.map((route) => ({
        addressCode: route.addressCode,
        name: route.name,
        address: route.address,
        type: route.type,
        controlOffice: route.sourceName,
      }));
      setData(addressListData);
    }
  }, [addressFilterData]);

  useEffect(() => {
    if (addressFilterData?.data?.lastEvaluatedKey) {
      if (paginatedArr.length === currentPage) {
        setPaginatedArr((prev) => [...prev, addressFilterData.data.lastEvaluatedKey]);
      }
    }
  }, [addressFilterData, currentPage]);

  useEffect(() => {
    if (addressData?.data?.lastEvaluatedKey) {
      if (paginatedArr.length === currentPage) {
        setPaginatedArr((prev) => [...prev, addressData.data.lastEvaluatedKey]);
      }
    }
  }, [addressData, currentPage]);

  // useEffect(() => {
  //   console.info(totalPages.current, paginatedArr.length, 'yashuu paginated lenth');
  //   totalPages.current = paginatedArr.length

  // }, [paginatedArr.length])

  useEffect(() => {
    if (debouncedSearchQuery) {
      const filteredDataArr = data.filter((address) =>
        address?.name ? address?.name.toLowerCase().includes(searchQuery.toLowerCase()) : false,
      );
      setFilteredData(filteredDataArr);
      totalPages.current = 1;
      setCurrentPage(1);
    } else {
      setFilteredData(data);
      totalPages.current = paginatedArr.length;
    }
  }, [debouncedSearchQuery, data]);

  const handlePageChange = async (event: React.ChangeEvent<unknown>, page: number) => {
    if (page !== 1) {
      if (filterData.isfiltered) {
        await fetchAddressFilterData({
          address: filterData.data.address ? filterData.data.address : '',
          type: filterData.data.type ? filterData.data.type : '',
          city: filterData.data.city ? filterData.data.city : '',
          category: filterData.data.category ? filterData.data.category : '',
          state: filterData.data.state ? filterData.data.state : '',
          pincode: filterData.data.pincode ? filterData.data.pincode : '',
          lastEvaluatedKey: paginatedArr[page - 1],
          fleetId: user?.customer_id,
        });
      } else {
        await fetchAddressData({
          lastEvaluatedKey: paginatedArr[page - 1],
          fleetId: user?.customer_id,
        });
        console.info('fetchAddressData:handlePageChange', { id: user?.customer_id });
      }
    } else {
      if (filterData.isfiltered) {
        await fetchAddressFilterData({
          address: filterData.data.address ? filterData.data.address : '',
          type: filterData.data.type ? filterData.data.type : '',
          city: filterData.data.city ? filterData.data.city : '',
          category: filterData.data.category ? filterData.data.category : '',
          state: filterData.data.state ? filterData.data.state : '',
          pincode: filterData.data.pincode ? filterData.data.pincode : '',
          lastEvaluatedKey: null,
          fleetId: user?.customer_id,
        });
      } else {
        console.info('fetchAddressData:handlePageChange:filterData');
        await fetchAddressData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
      }
    }
    setCurrentPage(page);
  };

  useEffect(() => {
    handleTile(tilesObj);
  }, [tilesObj]);

  // Define base columns and filter using columnObj settings
  const baseColumns: MRT_ColumnDef<Address>[] = useMemo(
    () => [
      {
        accessorKey: 'addressCode',
        header: 'Address Code',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: { sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' } },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'name',
        header: 'Name',
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'address',
        header: 'Address',
        muiTableBodyCellProps: {
          sx: { padding: '8px', whiteSpace: 'normal', wordBreak: 'break-word' },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            fontWeight={400}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'type',
        header: 'Type',
        muiTableBodyCellProps: {
          sx: { padding: '8px', whiteSpace: 'normal', wordBreak: 'break-word' },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            fontWeight={400}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'controlOffice',
        header: 'Control Office',
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'actions',
        header: 'Actions',
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ row }) => (
          <Typography
            variant="body2"
            fontWeight={700}
            color="primary"
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate(`${row.original.addressCode}`)}
          >
            <img src={eye} alt="View" style={{ width: 18, height: 18 }} />
          </Typography>
        ),
      },
    ],
    [isSmallScreen, navigate],
  );

  const columns: MRT_ColumnDef<Address>[] = useMemo(
    () => baseColumns.filter((column) => columnObj[column.accessorKey as keyof ColumnObjType]?.status),
    [baseColumns, columnObj],
  );

  const tableOptions: MRT_TableOptions<Address> = {
    columns,
    data: filteredData,
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    initialState: {
      // Adjust the pinning keys as needed
      columnPinning: {
        left: ['addressCode', 'name'],
        right: ['actions'],
      },
    },
    muiTableBodyProps: {
      sx: { padding: 0, margin: 0 },
    },
  };

  const table = useMaterialReactTable(tableOptions);
  console.info(paginatedArr, currentPage, paginatedArr.length, totalPages.current, 'yashuu');

  return (
    <>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      <div className="flex flex-col gap-4 w-full">
        {/* Search Input */}
        <div className="w-full flex justify-between gap-4 xs:flex-col">
          <div className="flex gap-2 items-center">
            <div className="max-w-[400px]">
              <TextField
                variant="outlined"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search"
                sx={(theme) => ({
                  '& .MuiOutlinedInput-root': {
                    borderColor: theme.palette.action.selected,
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                  },
                  '& .MuiInputBase-root': { padding: '0rem 1rem' },
                  '& .MuiOutlinedInput-input': {
                    padding: '0px 12px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                  },
                })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={searchIcon} alt="icon" width={16} height={16} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={(theme) => ({
                        height: '48px',
                        maxHeight: '48px',
                        display: 'flex',
                        cursor: 'pointer',
                        alignItems: 'center',
                        borderLeft: `1px solid ${theme.palette.action.selected}`,
                        paddingLeft: '8px',
                      })}
                    >
                      <img
                        src={filterIcon}
                        alt="icon"
                        onClick={() => setIsFilterModelOpen(true)}
                        width={24}
                        height={24}
                      />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '14px',
                    fontWeight: 500,
                  },
                }}
              />
            </div>
            {filterData.isfiltered && (
              <CustomIconButton
                text={`Clear Filters (${
                  Object.values(filterData.data).filter((value) => value !== '').length
                })`}
                background="transparent"
                outline={false} // Set to true if you want an outline
                textColor="#C83333"
                onClick={() => setFilterData({ data: {}, isfiltered: false })}
              />
            )}
          </div>
          <div className="flex gap-4 flex-wrap">
            <CustomIconButton
              icon={<img src={Custom} alt="Custom" width={16} height={16} />}
              text="Customize"
              background="transparent"
              outline={false}
              onClick={() => setIsCustomiseModalOpen(true)}
            />
            <CustomIconButton
              icon={<img src={bulkUpload} alt="Bulk Upload" width={24} height={24} />}
              text="Bulk Upload"
              background="transparent"
              outline={false}
              onClick={() => setIsUploadModelOpen(true)}
            />
            {/* <CustomIconButton
              icon={<img src={download} alt="Download" width={16} height={16} />}
              text="Download"
              background="transparent"
              variant="outlined"
              onClick={() => console.info('Download Button Clicked')}
            /> */}
            <CustomIconButton
              icon={
                <img
                  src={download}
                  alt="download"
                  width={16}
                  height={16}
                  style={filteredData.length === 0 ? { filter: 'grayscale(1)', opacity: 0.5 } : undefined}
                />
              }
              text="Download"
              background="transparent"
              variant="outlined"
              isDisabled={filteredData.length === 0}
              onClick={() => setIsDownloadModalOpen(true)}
            />
            <CustomIconButton
              icon={<img src={add} alt="Add" width={16} height={16} />}
              text="Add Address"
              variant="contained"
              onClick={() => navigate('new')}
            />
          </div>
        </div>
        <MaterialReactTable table={table} />
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={totalPages.current}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            color="primary"
            siblingCount={0}
            boundaryCount={0}
            renderItem={(item) => {
              if (item.type === 'page' && item.page !== null && item.page > currentPage) {
                return null;
              }
              return <PaginationItem {...item} />;
            }}
          />
        </Box>
      </div>
      {/* Render the CustomiseTableModal when Customize is clicked */}
      <CustomFilterModal
        open={isFilterModel}
        onClose={() => setIsFilterModelOpen(false)}
        onReset={() => console.info('Reset filter!')}
        title="Filter Address"
        filterFields={filterFileds}
        onApply={(data: any) => setFilterData({ data: data, isfiltered: true })}
        description="Refine the address list with these filters."
      />
      <CustomiseTableModal
        open={isCustomiseModalOpen}
        onClose={handleClose}
        onReset={handleReset}
        title="Customize Your Table"
        description="Select and arrange table columns as you prefer."
        columnObj={columnObj}
        tilesObj={tilesObj}
        setTilesObj={setTilesObj}
        setColumnObj={setColumnObj}
      />

      <DownloadData
        downloadLoading={downloadTripLoading}
        isDownloadModalOpen={isDownloadModalOpen}
        handleDownloadModalClose={() => setIsDownloadModalOpen(false)}
        selectedFormat={selectedFormat}
        handleFormatChange={(e: React.ChangeEvent<HTMLInputElement>) => setSelectedFormat(e.target.value)}
        handleDownload={handleDownload}
        modalTitle={
          selectedTrip?.tripId ? `Download ${selectedTrip?.tripId}` : 'Download Ignition based Trips Data'
        }
        modalDescription="Please select a file format for your download."
        formatLabel="Format"
        formatExcelLabel="Excel"
        formatCsvLabel="CSV"
        formatPdfLabel="PDF"
        cancelButtonText="Cancel"
        downloadButtonText="Download"
      />
      {isUploadModelOpen && (
        <BulkUploadModal
          open={isUploadModelOpen}
          handleClose={handleUploadModalClose}
          uploadEndpoint={API_ENDPOINTS.directories.ADDRESS_BULK_UPLOAD}
          title="Bulk Upload"
          description="Upload an Excel/CSV files to add multiple addresses at once!"
          entityType="addresses"
          sampleFileUrl={API_ENDPOINTS.directories.ADDRESS_SAMPLE_DOWNLOAD}
        />
      )}
    </>
  );
};

export default AddressesDataTable;
